var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade-opacity"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],attrs:{"id":"spinner"}},[_c('img',{attrs:{"src":require("@/assets/images/spinner.png"),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }